new Swiper('.latest-blog-posts .swiper', {
  slidesPerView: 2,
  spaceBetween: 0,
  breakpoints: {
    985: {
      slidesPerView: 3,
    },
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
})
